import { useContext } from "react";
import { UserProtectionTokensContext } from "@/shared/security/model/user-protection-tokens/context";

export function useUserProtectionTokens() {
  return useContext(UserProtectionTokensContext);
}
